import React, { Component } from "react";
import styled from "styled-components";

import { primary } from "@formant/ui/component/common/Colors";

import { TextInput } from "./TextInput";
import { IInputProps, IJsonStringSchema } from "./types";

export class ListInput extends Component<IInputProps<IJsonStringSchema>> {
    public render() {
        return (
            <Container>
                <TextInput {...this.props} />
            </Container>
        );
    }
}

const Container = styled.div`
    &&& span {
        border-bottom: 0px;
    }

    &&& input {
        position: relative;
        width: 100%;
        height: 2.5rem;
        border-radius: 0.1875rem;
        background-color: ${primary.steel02};
        display: flex;
        padding-left: 0.625rem;
        align-items: center;
        margin-bottom: 0.125rem;
    }
`;
